<template>
  <li class="check-list-child check-list__result-item">
    <check-box
      :with-toggle="hasChildren"
      :field-label="childItem.name"
      :field-name="childItem.slug"
      :initial-value="isChecked"
      :toggle-open="selectionOpen"
      @on-change="handleChange($event)"
      @on-toggle="selectionOpen = !selectionOpen"/>
    <ul v-if="hasChildren && selectionOpen" class="check-list__child-result-list">
      <check-list-child
        v-for="item in relevantTree"
        :key="item.term_id"
        :selected-items="selectedItems"
        :flat-list="flatList"
        :child-item="item"
        @on-change="$emit('on-change', $event)"/>
    </ul>
  </li>
</template>

<script lang="ts">
import CheckBox from "~/components/UI/CheckBox.vue";
import type { TreeItem } from "~/components/UI/CheckList.vue";

export default {
  name: 'CheckListChild',
  components: {
    CheckBox,
  },
  props: {
    childItem: Object as TreeItem,
    flatList: Array,
    selectedItems: Array,
  },
  data () {
    return {
      selectionOpen: false,
    };
  },
  computed: {
    relevantTree (): TreeItem[] {
      const tree = this.flatList.filter((item) => item.parent === this.childItem.term_id);

      return tree?.sort((a, b) => a.name < b.name ? -1 : 1);
    },
    hasChildren () {
      return this.relevantTree.length > 0;
    },
    isChecked () {
      return this.selectedItems?.includes(this.childItem.slug);
    },
  },
  methods: {
    handleChange () {
      this.$emit('on-change', this.childItem);
    },
  },
};
</script>
